"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organism = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const node_1 = require("../common/node");
/**
 * The base class for all organisms.
 * @category Organisms
 */
class Organism extends node_1.Node {
    constructor(name, organisms) {
        super(name, organisms);
        this.organisms = organisms;
    }
}
exports.Organism = Organism;
